import { v4 as uuidv4 } from "uuid";

// Function to generate a UUID
export const generateUUID = () => {
  return uuidv4();
};
